import React, { createRef } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { parseJwt } from "../parseJWT";
import axios from "axios";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
// import { Code } from "@material-ui/icons";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
require("../_css/PopUpOther.css");
//require('./Productbring.css')
export default class PopUpOther extends React.Component {
  constructor(props) {
    super(props);
    this.Code = createRef();
    this.state = {
      type: this.props.type,
      col: [],
      rows: [],
      valueRetuen: "",
      Htext: "",
      SHtype: 3,
      showSH: "",
      textSearch: "",
      autoClose: 3600,
      selected: "",
      messagealert: "",
      openBackdrop: false,
    };
  }
  componentDidMount() {
    this.setState({ selected: "0" });
    //------------------------------------------ get setcode user ---------------------------------------------
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    console.log("SITECODESTR", SITECODESTR);
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setState({ userCode: SITECODESTR.User.CODE });
    if (this.props.productcodeinrow !== "") {
      this.setState({ productcodeinrow: this.props.productcodeinrow.trim() });
    }
    if (this.props.from) {
      this.setState({ from_s: this.props.from });
    }
    setTimeout(() => {
      this._loadData(this.state.productcodeinrow);
    }, 50);
  }

  _loadData = (productcodeinrow, Search) => {
    this.setState({ openBackdrop: true });
    this.setState({ Htext: "ที่เก็บ" });
    var SearchCode = "";
    // if (Search === "Y") {
    //     if (this.state.selected === "0") {
    //         SearchCode = "&warehouse=" + this.Code.current.value
    //     }
    //     if (this.state.selected === "1") {
    //         SearchCode = "&location=" + this.Code.current.value
    //     }
    // }
    var arrdata = [];
    var url =
      "STKWAREHOUSE/CSVSTKWarehouseaspermission?usercode=" +
      this.state.userCode +
      "&productcode=" +
      productcodeinrow +
      (Search === "Y"
        ? "&typesearch=" +
          this.state.selected +
          "&txtsearch=" +
          this.Code.current.value
        : "");
    console.log("urlSTKWAREHOUSE", genURL(url));
    axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          //   console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", res.data);
          for (let i = 0; i < res.data.length; i++) {
            arrdata[i] = {
              number: i + 1,
              WAREHOUSE: res.data[i].WAREHOUSE,
              WHNAME: res.data[i].WHNAME,
              LOCATION: res.data[i].LOCATION,
              LOCNAME: res.data[i].LOCNAME,
              STOCKQ: res.data[i].STOCKQTY,
              SALEORDER: res.data[i].SALEORDER,
            };
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.setState({ openBackdrop: false });
        }
      })
      .then((_) => {
        this.setState({ rows: arrdata });
        this.setState({ openBackdrop: false });
      })
      .catch((error) => {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
        this.setState({ openBackdrop: false });
      });
  };
  onSelectRow = (data) => {
    let reData =
      data.WAREHOUSE +
      "|" +
      data.WHNAME +
      "|" +
      data.LOCATION +
      "|" +
      data.LOCNAME +
      "|" +
      data.STOCKQ;
    console.log(this.props.from);
    if (
      this.props.from !== "CSPR" &&
      this.props.from !== "CSSALERET" &&
      this.props.from !== "CSSTKMOVEREQ" &&
      this.props.from !== "CSPURCHASE" &&
      this.props.from !== "CSStkMoveReq"
    ) {
      if (
        Number(data.STOCKQ) <= 0 &&
        this.state.type !== "setdefaultwarehouse2"
      ) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "จำนวนสินค้าไม่พอใช้งาน" });
        return;
      }
    }
    setTimeout(() => {
      this.props.Get_PopUpOther(reData);
      this.props.closePopup();
    }, 100);
  };
  onChangeRadio = (e) => {
    this.setState({ SHtype: e.target.value });
  };
  _onChange = (event) => {
    // console.log(event.target.value);
    this.setState({ textSearch: event.target.value });
  };
  _keyDown = (event) => {
    if (event.key === "Enter") {
      this._loadData(
        this.state.textSearch,
        this.state.selected,
        this.state.productcodeinrow
      );
    }
  };
  _onclickSearch() {
    this._loadData(
      this.state.textSearch,
      this.state.selected,
      this.state.productcodeinrow
    );
  }
  render() {
    // const MAX_HEIGHT = 600;
    // const ROW_HEIGHT = 20;
    return (
      <div className="popup">
        <Backdrop open={this.state.openBackdrop} />
        <div className="popup_inner">
          {this.props.Data}
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> {this.state.Htext} </i>
            </div>
            <div className="PopUpOtherDivH2">
              <i className="fas fa-times" onClick={this.props.closePopup}></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <div className="form-inline">
              <div className="form-group mb-2">
                <input
                  type="radio"
                  id="Choice-1"
                  name="myRadio"
                  value="0"
                  checked={this.state.selected === "0"}
                  onChange={(e) => this.setState({ selected: e.target.value })}
                />
                <span className="choiceSty">
                  &nbsp;ค้นหาจากรหัสสาขา&nbsp;&nbsp;&nbsp;
                </span>
                <input
                  type="radio"
                  id="Choice-2"
                  name="myRadio"
                  value="1"
                  checked={this.state.selected === "1"}
                  onChange={(e) => this.setState({ selected: e.target.value })}
                />
                <span className="choiceSty">
                  &nbsp;ค้นหาจากรหัสที่เก็บ&nbsp;
                </span>
              </div>
            </div>
            <div className="input-group width-grop">
              <input
                type="text"
                className="form-control"
                placeholder="กรอกรหัสสาขาหรือรหัสที่เก็บ"
                ref={this.Code}
                onKeyUp={this.textinputKeyUp}
              />
              <span className="input-group-addon txt-img icon">
                <i
                  className="fas fa-search"
                  onClick={() => {
                    this._loadData(this.state.productcodeinrow, "Y");
                  }}
                ></i>
              </span>
              <span className="input-group-addon txt-img icon">
                {" "}
                <i
                  className="fas fa-sync-alt"
                  onClick={() => {
                    this._loadData(this.state.productcodeinrow);
                  }}
                ></i>
              </span>
            </div>
            <BootstrapTable
              data={this.state.rows}
              options={{
                onRowClick: this.onSelectRow,
                noDataText: "ไม่พบข้อมูลที่ค้นหา",
              }}
              height="700"
              condensed
            >
              <TableHeaderColumn
                columnClassName="columnAll? columnID"
                className="columnNumber"
                dataAlign="center"
                width="30"
                dataField="number"
                isKey
              >
                {" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="100"
                dataField="WAREHOUSE"
              >
                {" "}
                รหัส{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="120"
                dataField="WHNAME"
              >
                {" "}
                สาขา{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="100"
                dataField="LOCATION"
              >
                {" "}
                รหัสที่เก็บ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="120"
                dataField="LOCNAME"
              >
                {" "}
                ที่เก็บ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="100"
                dataField="STOCKQ"
              >
                {" "}
                คงเหลือ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll?"
                className="columnNumber"
                width="100"
                dataField="SALEORDER"
              >
                {" "}
                ค้างส่ง{" "}
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          <i id="load"></i>
        </div>
        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </div>
    );
  }
}
